// extracted by mini-css-extract-plugin
export var background = "homePage-module--background--06b0d";
export var carouselLarge = "homePage-module--carouselLarge--4c8a8";
export var container = "homePage-module--container--044b5";
export var exploreWrapper = "homePage-module--exploreWrapper--59a23";
export var inner = "homePage-module--inner--d3b7a";
export var reviewBadges = "homePage-module--reviewBadges--46b7f";
export var smartAutomations = "homePage-module--smartAutomations--8ba71";
export var solutionsMarquee = "homePage-module--solutionsMarquee--4842f";
export var threeColumn = "homePage-module--threeColumn--5b760";
export var whyMangomint = "homePage-module--whyMangomint--67f01";
export var wrapper = "homePage-module--wrapper--d3f82";